import { z } from 'zod'

const createPmaAnalysisRequestSchema = z.object({
  name: z.string(),
  assets: z.array(z.string()),
  exchanges: z.array(z.string()),
  timeHorizon: z.tuple([z.string().datetime(), z.string().datetime()]),
  includeCrypto: z.boolean(),
  includeFiat: z.boolean(),
  includeStablecoins: z.boolean(),
})
export type CreatePmaAnalysisRequest = z.infer<typeof createPmaAnalysisRequestSchema>

export const pmaAnalysisSchema = createPmaAnalysisRequestSchema.extend({
  id: z.string(),
  org: z.string(),
  lastRun: z.string(),
  status: z.string(),
})
export type PmaAnalysis = z.infer<typeof pmaAnalysisSchema>

export const fetchPmaAnalysesResponseSchema = z.array(pmaAnalysisSchema)

const pmaExchangeAnalysisResult = z.object({
  exchange: z.string(),
  volume: z.number(),
})
export type PmaExchangeAnalysisResult = z.infer<typeof pmaExchangeAnalysisResult>

const pmaAnalysisResult = z.object({
  asset: z.string(),
  current_market: z.string(),
  exchanges: z.array(pmaExchangeAnalysisResult),
})
export type PmaAnalysisResult = z.infer<typeof pmaAnalysisResult>
export const runPmaAnalysisResponseSchema = z.array(pmaAnalysisResult)
export type RunPmaAnalysisResponse = z.infer<typeof runPmaAnalysisResponseSchema>

export const fetchPmaCurrenciesResponseSchema = z.array(z.string())

export const fetchPmaExchangesResponseSchema = z.array(z.string())
